













































import Vue, { PropType } from 'vue';
import { ConfigurationItem } from '@/models/configurator/configuration';
import { roundCurrency } from '@/utils/helpers';

export default Vue.extend({
  props: {
    exchangeRate: Number,
    currencyCode: String,

    configurationItems: {
      type: Array as PropType<ConfigurationItem[]>
    }
  },

  computed: {
    totalItemPrice(): number {
      const reducer = (accumulator: number, price: number) =>
        accumulator + price;

      return this.configurationItems
        .map(
          item =>
            this.roundCurrency(item.unit_price! * this.exchangeRate) *
            item.quantity!
        )
        .reduce(reducer, 0);
    }
  },

  methods: {
    roundCurrency
  }
});
